import I18n from "i18n-js"
import translations from "translations"

// TODO: export this as a module instead of a function
export default function i18nSetup() {
  I18n.locale = window.locale
  I18n.defaultLocale = window.default_locale
  I18n.translations = translations
  return I18n
}
